export default function always<T>(e: T) {
  return function _a(): T {
    return e;
  };
}
